import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as Closeicon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play.svg";
import Util from "./util";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../Components/Loading/Loading";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ShowCard from "../../Components/ShowCard/ShowCard";
import Translate from "../../Components/Multilanguage/Translate";
import { updateUserRating } from "../../network/service";
import { getShowDetails } from "./service";
import { likeHandlerShorts, stripHtml } from "../../utils/utils";
import {
  fetchComments,
  createComment,
  likeDislikeComment,
} from "../../Components/Comments/service";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "./scss/_yowDetailsScreen.scss";
import AddToPlaylistPopup from "./Components/AddToPlaylistPopup";

let videoStarted = false;

const formatShortTimeAgo = (dateInput) => {
  if (!dateInput) return "Just now";
  let unixTime;
  if (typeof dateInput === "number") {
    unixTime = dateInput > 1e11 ? dateInput / 1000 : dateInput;
  } else {
    const parsed = new Date(dateInput).getTime();
    if (isNaN(parsed)) return String(dateInput);
    unixTime = parsed / 1000;
  }
  const diff = Math.floor(Date.now() / 1000 - unixTime);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
  if (diff < 2419200) return `${Math.floor(diff / 604800)}w`;
  if (diff < 29030400) return `${Math.floor(diff / 2419200)}mo`;
  return `${Math.floor(diff / 29030400)}y`;
};

const formatUserHandle = (userObj, fallbackName) => {
  const raw =
    userObj?.user_name ||
    userObj?.name ||
    userObj?.first_name ||
    fallbackName ||
    "viewer";
  const clean = String(raw).trim();
  return clean.startsWith("@") ? clean : `@${clean}`;
};

const getAvatarInitial = (userObj, fallbackName) => {
  const name =
    userObj?.user_name ||
    userObj?.name ||
    userObj?.first_name ||
    fallbackName ||
    "V";
  const clean = String(name).replace(/^@/, "").trim();
  return clean.charAt(0).toUpperCase() || "V";
};

const MOCK_SIMILAR_VIDEOS = [
  {
    show_id: 101,
    title: "The Counterculture Icon",
    show_name: "The Counterculture Icon",
    poster_image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&auto=format&fit=crop&q=80",
    genre: "Documentary",
    year: "2024",
    vanity_url: "counterculture-icon",
    synopsis: "The untold story of Maine's most authentic counterculture icon, featuring never-before-seen footage.",
    director: "YOW Films",
    duration_text: "1h 42m"
  },
  {
    show_id: 102,
    title: "Bees & Freedom",
    show_name: "Bees & Freedom",
    poster_image: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=800&auto=format&fit=crop&q=80",
    genre: "Biography",
    year: "2023",
    vanity_url: "bees-freedom",
    synopsis: "A deep dive into living wild, surviving hardship, and harvesting nature's sweetest gifts.",
    director: "Nature Media",
    duration_text: "58m"
  },
  {
    show_id: 103,
    title: "Wild & Unfiltered",
    show_name: "Wild & Unfiltered",
    poster_image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=800&auto=format&fit=crop&q=80",
    genre: "Indie",
    year: "2025",
    vanity_url: "wild-unfiltered",
    synopsis: "Unfiltered conversations, rustic humor, and real grit from the heart of the woods.",
    director: "Indie Collective",
    duration_text: "1h 15m"
  },
  {
    show_id: 104,
    title: "The Off-Grid Legend",
    show_name: "The Off-Grid Legend",
    poster_image: "https://images.unsplash.com/photo-1518676590629-3dcbd9c7a5c1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1518676590629-3dcbd9c7a5c1?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1518676590629-3dcbd9c7a5c1?w=800&auto=format&fit=crop&q=80",
    genre: "Drama",
    year: "2024",
    vanity_url: "off-grid-legend",
    synopsis: "How an icon carved out a life on his own terms away from modern noise.",
    director: "Frontier Visions",
    duration_text: "1h 30m"
  },
  {
    show_id: 105,
    title: "Natural Born Rebel",
    show_name: "Natural Born Rebel",
    poster_image: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&auto=format&fit=crop&q=80",
    genre: "Comedy",
    year: "2023",
    vanity_url: "natural-born-rebel",
    synopsis: "Laugh along with hilarious anecdotes, rugged pranks, and backwoods philosophy.",
    director: "Laughter Works",
    duration_text: "48m"
  },
  {
    show_id: 106,
    title: "Maine Wilderness",
    show_name: "Maine Wilderness",
    poster_image: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=800&auto=format&fit=crop&q=80",
    genre: "Adventure",
    year: "2025",
    vanity_url: "maine-wilderness",
    synopsis: "Breathtaking landscapes and rugged tales from northern New England.",
    director: "Wild Maine Productions",
    duration_text: "1h 05m"
  },
  {
    show_id: 107,
    title: "Living Free",
    show_name: "Living Free",
    poster_image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&auto=format&fit=crop&q=80",
    genre: "Documentary",
    year: "2024",
    vanity_url: "living-free",
    synopsis: "Exploring what true freedom means in a world of endless restrictions.",
    director: "Free Spirits",
    duration_text: "52m"
  },
  {
    show_id: 108,
    title: "Behind The Beard",
    show_name: "Behind The Beard",
    poster_image: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=800&auto=format&fit=crop&q=80",
    genre: "Biography",
    year: "2025",
    vanity_url: "behind-the-beard",
    synopsis: "The man, the myth, the beard. A candid portrait of an undeniable icon.",
    director: "Portraiture Films",
    duration_text: "1h 20m"
  },
  {
    show_id: 109,
    title: "Tales from the North",
    show_name: "Tales from the North",
    poster_image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&auto=format&fit=crop&q=80",
    genre: "Folklore",
    year: "2024",
    vanity_url: "tales-from-the-north",
    synopsis: "Fireside stories and hidden lore gathered from woodsmen across Maine.",
    director: "Northern Chronicle",
    duration_text: "1h 10m"
  },
  {
    show_id: 110,
    title: "Woodland Chronicles",
    show_name: "Woodland Chronicles",
    poster_image: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=800&auto=format&fit=crop&q=80",
    genre: "Nature",
    year: "2023",
    vanity_url: "woodland-chronicles",
    synopsis: "A year-round journey through changing seasons deep in the pine wilderness.",
    director: "Evergreen Arts",
    duration_text: "55m"
  },
  {
    show_id: 111,
    title: "Rustic Echoes",
    show_name: "Rustic Echoes",
    poster_image: "https://images.unsplash.com/photo-1511497584788-87676104235f?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1511497584788-87676104235f?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1511497584788-87676104235f?w=800&auto=format&fit=crop&q=80",
    genre: "Acoustic",
    year: "2025",
    vanity_url: "rustic-echoes",
    synopsis: "Original music, front-porch picking, and authentic acoustic sessions from the backwoods.",
    director: "Timber Sound",
    duration_text: "1h 05m"
  },
  {
    show_id: 112,
    title: "The River Way",
    show_name: "The River Way",
    poster_image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=500&auto=format&fit=crop&q=60",
    banner: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&auto=format&fit=crop&q=80",
    genre: "Expedition",
    year: "2024",
    vanity_url: "the-river-way",
    synopsis: "Navigating untamed waters and rediscovering forgotten water routes.",
    director: "Paddle & Quill",
    duration_text: "1h 25m"
  }
];

const YowDetailsScreen = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const userSubscriptionData = useSelector(
    (state) => state?.userSubscription?.value
  );
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [videoPlay, setVideoPlay] = useState(false);
  const [watchDuration, setWatchDuration] = useState("");
  const [showDetails, setShowDetails] = useState({});
  const [similarVideos, setSimilarVideos] = useState([]);
  const [playerToken, setPlayerToken] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videoPlayer, setVideoPlayer] = useState("");
  const [watchlistStatus, setWatchlistStatus] = useState("removed");
  const [showAddtoPlaylistPopup, setShowAddtoPlaylistPopup] = useState(false);
  const [selectedVideoDetails, setSelectedVideoDetails] = useState();
  const [categories, setCategories] = useState("");
  const [loading, setLoading] = useState(true);
  const [subscribedUser, setSubscribeduser] = useState(false);
  const [subscribeButton, setSubscribeButton] = useState();
  const [isFreeVideo, setIsFreeVideo] = useState(false);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [isTrailer, setIsTrailer] = useState(false);
  const [isFullReviewOpen, setIsFullReviewOpen] = useState(false);
  const [isCreatorsModalOpen, setIsCreatorsModalOpen] = useState(false);
  const [userRatedCount, setUserRatedValue] = useState();
  const [isEditingRating, setIsEditingRating] = useState(false);
  const [draftRating, setDraftRating] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(null);

  // Custom Interactive YOWTV States
  const [isMuted, setIsMuted] = useState(true);
  const [likesCount, setLikesCount] = useState(0);
  const [hasLiked, setHasLiked] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [commentsList, setCommentsList] = useState([]);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [modalCommentsList, setModalCommentsList] = useState([]);
  const [modalCommentInput, setModalCommentInput] = useState("");
  const [totalCommunityComments, setTotalCommunityComments] = useState(0);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [isSubmittingModalComment, setIsSubmittingModalComment] = useState(false);

  const storedUserId = typeof window !== "undefined" ? localStorage.getItem("userId") : null;
  const isGuestUser = Boolean(
    userDetails?.is_guest === true ||
    userDetails?.is_guest === "true" ||
    userDetails?.is_guest === 1 ||
    userDetails?.is_guest === "1"
  );
  const hasRealUser = Boolean(
    (storedUserId && storedUserId !== "null" && storedUserId !== "undefined" && storedUserId.trim() !== "") ||
    (user && user !== "null" && user !== "undefined" && String(user).trim() !== "")
  );
  const isUserLoggedIn = Boolean(!isGuestUser && hasRealUser);

  const location = useLocation();
  const [showId, setShowId] = useState();
  const type = location?.state?.type;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const windowSize = useWindowWidth();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const playerRef = useRef(null);

  const {
    fetchShowDetails,
    fetchShowDetailsByVanityUrl,
    fetchSimilarVideos,
    fetchPlayerToken,
    addToWatchlist,
    removeFromWatchlist,
    subscriptionCheck,
    handleSubscribe,
    watchVideoHandler,
    handleWatchNowClick,
    updateVideoAnalytics,
    fetchUserSubscriptionDetails,
  } = Util();

  useEffect(() => {
    fetchUserSubscriptionDetails(appInfo, dispatch);
  }, []);

  useEffect(() => {
    if (
      location?.state?.thumbnailOrientation === "PORTRAIT" ||
      (!location?.state?.thumbnailOrientation &&
        projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT")
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (showDetails && Object.keys(showDetails).length > 0) {
      setLoading(false);
      if (showDetails?.user_rated === true) {
        setUserRatedValue(showDetails?.user_rating);
        setDraftRating(Number(showDetails?.user_rating));
      } else {
        setUserRatedValue(null);
        setDraftRating(null);
      }
      if (showDetails?.categories) {
        let categoryNames = showDetails?.categories
          ?.map((item) => item?.category_name)
          .join(", ");
        setCategories(categoryNames);
      }
      const detailLikesCount = Number(showDetails?.like_count);
      setLikesCount(Number.isFinite(detailLikesCount) ? detailLikesCount : 0);
      setHasLiked(showDetails?.liked_flag === true);
      if (Array.isArray(showDetails?.comments)) {
        setCommentsList(
          showDetails.comments.slice(0, 3).map((comment, index) => ({
            id: comment?.id || comment?.comment_id || index,
            name: comment?.user?.user_name?.trim() || comment?.name || comment?.user_name || comment?.username || "Viewer",
            image: comment?.user?.user_image || comment?.image_url || null,
            time: comment?.time || comment?.created_at || "",
            text: comment?.content || comment?.text || comment?.comment || comment?.comment_text || "",
            likes: Number(comment?.likes_count ?? comment?.likes ?? comment?.like_count ?? 0),
            liked: comment?.user_has_liked === true || comment?.liked === true || comment?.liked_flag === true,
          }))
        );
        setModalCommentsList(showDetails.comments);
        setTotalCommunityComments(showDetails.comments.length);
      } else {
        setCommentsList([]);
      }
      if (showDetails?.watchlist_flag === 1) {
        setWatchlistStatus("added");
      } else {
        setWatchlistStatus("removed");
      }
      if (showDetails?.single_video === 1 && showDetails?.videos?.length > 0) {
        setSelectedVideoDetails(showDetails?.videos[0]);
      } else if (showDetails?.videos && showDetails?.videos[0]?.videos) {
        setSelectedVideoDetails(showDetails?.videos[0]?.videos[0]);
      } else if (showDetails?.videos && showDetails?.videos[0]) {
        setSelectedVideoDetails(showDetails?.videos[0]);
      }
    }
  }, [showDetails, type]);

  useEffect(() => {
    window.scroll(0, 0);
    const safetyTimer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    if (location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      let stateShowId = location?.state?.showId;
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          setLoading,
          setShowDetails,
          setShowId,
          setSimilarVideos,
          stateShowId || showId
        );
      } else {
        fetchShowDetails(setLoading, setShowDetails, appInfo, stateShowId || showId);
      }
      if (stateShowId || showId) {
        fetchSimilarVideos(null, appInfo, setSimilarVideos, stateShowId || showId);
      }
    }
    return () => clearTimeout(safetyTimer);
  }, [accessToken, projectInfo, location?.pathname]);

  useEffect(() => {
    if (refetchTrigger && location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          () => { },
          setShowDetails,
          setShowId,
          setSimilarVideos,
          showId
        );
      } else {
        fetchShowDetails(() => { }, setShowDetails, appInfo, showId);
      }
    }
  }, [refetchTrigger]);

  useEffect(() => {
    if (selectedVideoDetails && Object.keys(selectedVideoDetails).length > 0) {
      if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
        if (projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true") {
          let isSubscribedUser = false;
          if (showDetails?.subscriptions?.length > 0) {
            isSubscribedUser = userSubscriptionData?.data?.length > 0
              ? subscriptionCheck(userSubscriptionData?.data, showDetails?.subscriptions)
              : false;
          } else {
            isSubscribedUser = userSubscriptionData?.data?.length > 0
              ? subscriptionCheck(userSubscriptionData?.data, selectedVideoDetails?.subscriptions)
              : false;
          }
          if (isSubscribedUser === true) {
            setSubscribeduser(true);
            setSubscribeButton(false);
          } else {
            setSubscribeduser(false);
            if (selectedVideoDetails?.free_video === true) {
              setSubscribeButton(false);
              setIsFreeVideo(true);
            } else {
              setSubscribeButton(true);
              setIsFreeVideo(false);
            }
          }
        } else {
          setSubscribeduser(true);
          setSubscribeButton(false);
        }
      } else {
        setSubscribeButton(false);
        setSubscribeduser(true);
      }
    }
  }, [selectedVideoDetails, userSubscriptionData]);

  useEffect(() => {
    setVideoPlayer(null);
    if (videoUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{ src: `${videoUrl}`, type: "application/x-mpegURL" }],
      };
      setLoading(false);
      setVideoPlayer(
        <VideoJS
          autoplay={true}
          options={videoJsOptions}
          onReady={handlePlayerReady}
          isTrailer={true}
          poster={showDetails?.thumbnail_350_200 || showDetails?.poster_image || showDetails?.banner_portrait || showDetails?.banner || showDetails?.thumbnail}
        />
      );
    }
  }, [videoUrl, showDetails]);

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    player.on("play", () => {
      let event = videoStarted === true ? "POP09" : "POP02";
      videoStarted = true;
      updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
    });
  };

  const handleWatchlistToggle = () => {
    if (!user) {
      navigate(
        projectInfo?.projectConfig?.pubid !== 50124 &&
          projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true"
          ? "/checkout"
          : "/login",
        {
          state: {
            path: location?.pathname,
            showId: showId,
            activeLogin: true,
          },
        }
      );
      return;
    }
    setShowAddtoPlaylistPopup(true);
  };

  const handleLikeToggle = async () => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    const nextLikedState = !hasLiked;
    const targetShowId = showDetails?.show_id || showId || showDetails?.post_id;

    if (!targetShowId) return;

    const response = await likeHandlerShorts(
      "like/show",
      { id: targetShowId, liked: nextLikedState },
      appInfo
    );

    const responseStatus = response?.status;
    const likeSucceeded = response != null &&
      response?.success !== false &&
      (responseStatus === undefined || (responseStatus >= 200 && responseStatus < 300));

    if (likeSucceeded) {
      setLikesCount((prev) => nextLikedState ? prev + 1 : Math.max(0, prev - 1));
      setHasLiked(nextLikedState);
      setShowDetails((prev) => ({
        ...prev,
        liked_flag: nextLikedState,
        like_count: nextLikedState
          ? (Number(prev?.like_count) || 0) + 1
          : Math.max(0, (Number(prev?.like_count) || 0) - 1),
      }));
    }
  };

  const handleRatingSave = async () => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    if (!draftRating) return;

    const numRating = Number(draftRating);
    const prevUserRating = numericDetailValue(userRatedCount, showDetails?.user_rating);
    const prevCount = numericDetailValue(showDetails?.number_of_rating) ?? (prevUserRating > 0 ? 1 : 0);
    const prevScore = numericDetailValue(showDetails?.show_rating, prevUserRating);

    let newCount = prevCount > 0 ? prevCount : 1;
    let newScore = numRating;

    if (prevScore !== null && prevCount > 0) {
      if (prevUserRating !== null && prevUserRating > 0) {
        newScore = Number(
          Math.min(10, Math.max(0, (prevScore * prevCount - prevUserRating + numRating) / prevCount)).toFixed(1)
        );
      } else {
        newCount = prevCount + 1;
        newScore = Number(
          Math.min(10, Math.max(0, (prevScore * prevCount + numRating) / newCount)).toFixed(1)
        );
      }
    }

    setUserRatedValue(numRating);
    setIsEditingRating(false);
    setShowDetails((prev) => ({
      ...prev,
      show_rating: newScore,
      user_rating: numRating,
      user_rated: true,
      number_of_rating: newCount,
    }));

    try {
      const currentShowId = showDetails?.show_id || showId;
      const response = await updateUserRating(appInfo, {
        showId: currentShowId,
        ratedCount: numRating,
        review: "",
      });

      if (response?.status === 200) {
        const apiScore = response?.data?.data?.show_rating ??
          response?.data?.show_rating ??
          response?.data?.data?.rating ??
          response?.data?.rating;
        if (apiScore !== undefined && apiScore !== null && !Number.isNaN(Number(apiScore))) {
          setShowDetails((prev) => ({
            ...prev,
            show_rating: Number(apiScore),
          }));
        }
        if (currentShowId) {
          getShowDetails(appInfo, currentShowId).then((res) => {
            if (res?.status === 200 && res?.data?.data) {
              setShowDetails((prev) => ({
                ...prev,
                ...res.data.data,
              }));
            }
          }).catch(() => { });
        }
      }
    } catch (err) {
      console.error("Error updating user rating:", err);
    }
  };

  const handleInitialRating = async (rating) => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    const numRating = Number(rating);
    setUserRatedValue(numRating);
    setDraftRating(numRating);

    const prevCount = numericDetailValue(showDetails?.number_of_rating) ?? 0;
    const prevScore = numericDetailValue(showDetails?.show_rating);
    const newCount = prevCount > 0 ? prevCount + 1 : 1;
    const newScore = prevScore !== null && prevCount > 0
      ? Number(Math.min(10, Math.max(0, (prevScore * prevCount + numRating) / newCount)).toFixed(1))
      : numRating;

    setShowDetails((prev) => ({
      ...prev,
      show_rating: newScore,
      user_rating: numRating,
      user_rated: true,
      number_of_rating: newCount,
    }));

    try {
      const currentShowId = showDetails?.show_id || showId;
      const response = await updateUserRating(appInfo, {
        showId: currentShowId,
        ratedCount: numRating,
        review: "",
      });

      if (response?.status === 200) {
        const apiScore = response?.data?.data?.show_rating ??
          response?.data?.show_rating ??
          response?.data?.data?.rating ??
          response?.data?.rating;
        if (apiScore !== undefined && apiScore !== null && !Number.isNaN(Number(apiScore))) {
          setShowDetails((prev) => ({
            ...prev,
            show_rating: Number(apiScore),
          }));
        }
        if (currentShowId) {
          getShowDetails(appInfo, currentShowId).then((res) => {
            if (res?.status === 200 && res?.data?.data) {
              setShowDetails((prev) => ({
                ...prev,
                ...res.data.data,
              }));
            }
          }).catch(() => { });
        }
      }
    } catch (err) {
      console.error("Error updating user rating:", err);
    }
  };

  const handleRatingCancel = () => {
    setDraftRating(userRatedCount ?? null);
    setIsEditingRating(false);
  };

  const handleGuestCommentClick = () => {
    const currentShowId = showId || showDetails?.show_id || showDetails?.post_id;
    try {
      localStorage.setItem("vanityUrl", "");
    } catch (e) { }
    navigate(
      projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED !== "true"
        ? "/login"
        : "/checkout",
      {
        state: {
          path: location?.pathname,
          showId: currentShowId,
          activeLogin: true,
        },
      }
    );
  };

  const loadCommunityComments = async () => {
    const currentPostId = showDetails?.post_id || showDetails?.show_id || showId;
    if (!currentPostId) return;
    try {
      setCommentsLoading(true);
      const params = {
        video_id: currentPostId,
        post_id: currentPostId,
        sort: "Popular",
        page: 1,
        timestamp: Date.now(),
      };
      const response = await fetchComments(appInfo, params);
      if (response?.data?.success || response?.status === 200) {
        const comments = response?.data?.data || [];
        setModalCommentsList(comments);
        setTotalCommunityComments(response?.data?.total ?? comments.length);
        if (comments.length > 0) {
          setCommentsList(
            comments.slice(0, 3).map((item) => ({
              id: item.id,
              name: item.user?.user_name || item.name || "Viewer",
              time: formatShortTimeAgo(item.created_at || item.time),
              text: item.content || item.text || "",
              likes: Number(item.likes_count ?? item.likes ?? 0),
              liked: Boolean(item.user_has_liked || item.liked),
              image: item.user?.user_image || item.image || null,
            }))
          );
        } else if (response?.data?.total === 0) {
          setCommentsList([]);
        }
      }
    } catch (err) {
      console.error("Error fetching community comments:", err);
    } finally {
      setCommentsLoading(false);
    }
  };

  useEffect(() => {
    const currentPostId = showDetails?.post_id || showDetails?.show_id || showId;
    if (currentPostId) {
      loadCommunityComments();
    }
  }, [showDetails?.post_id, showDetails?.show_id, showId, accessToken]);

  useEffect(() => {
    if (isCommentsModalOpen) {
      loadCommunityComments();
    }
  }, [isCommentsModalOpen]);

  const handleAddComment = async () => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    if (!newComment.trim()) return;

    const currentPostId = showDetails?.post_id || showDetails?.show_id || showId;
    const commentText = newComment.trim();
    setNewComment("");

    const tempId = Date.now();
    const item = {
      id: tempId,
      name:
        userDetails?.first_name ||
        user?.first_name ||
        user?.name ||
        (typeof user === "string" && !user.match(/^\d+$/) ? user : "Viewer"),
      time: "Just now",
      text: commentText,
      likes: 0,
      liked: false,
    };
    setCommentsList((prev) => [item, ...prev].slice(0, 3));
    setTotalCommunityComments((prev) => prev + 1);

    if (currentPostId) {
      try {
        await createComment(appInfo, {
          content: commentText,
          post_id: Number(currentPostId),
          video_id: Number(currentPostId),
        });
        loadCommunityComments();
      } catch (err) {
        console.error("Error creating comment from card:", err);
      }
    }
  };

  const handleLikeComment = async (index) => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    const updated = [...commentsList];
    const target = updated[index];
    if (!target) return;
    const currentLiked = Boolean(target.liked);
    const newLiked = !currentLiked;
    target.liked = newLiked;
    target.likes = newLiked ? target.likes + 1 : Math.max(0, target.likes - 1);
    setCommentsList(updated);

    setModalCommentsList((prev) =>
      prev.map((c) => {
        if (c.id === target.id) {
          const count = Number(c.likes_count ?? c.likes ?? 0);
          return {
            ...c,
            user_has_liked: newLiked,
            liked: newLiked,
            likes_count: newLiked ? count + 1 : Math.max(0, count - 1),
            likes: newLiked ? count + 1 : Math.max(0, count - 1),
          };
        }
        return c;
      })
    );

    if (target.id) {
      try {
        await likeDislikeComment(appInfo, target.id, {
          liked: newLiked ? 1 : 0,
        });
      } catch (err) {
        console.error("Error liking comment:", err);
      }
    }
  };

  const handleModalAddComment = async () => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    if (!modalCommentInput.trim() || isSubmittingModalComment) return;

    const currentPostId = showDetails?.post_id || showDetails?.show_id || showId;
    const commentText = modalCommentInput.trim();
    setIsSubmittingModalComment(true);

    const tempId = Date.now();
    const optimisticItem = {
      id: tempId,
      content: commentText,
      created_at: new Date().toISOString(),
      time: "Just now",
      likes_count: 0,
      user_has_liked: false,
      user: {
        user_name:
          userDetails?.first_name ||
          user?.first_name ||
          (typeof user === "string" && !user.match(/^\d+$/) ? user : "you"),
        user_image: userDetails?.user_image || null,
      },
    };

    setModalCommentsList((prev) => [optimisticItem, ...prev]);
    setTotalCommunityComments((prev) => prev + 1);
    setCommentsList((prev) => [
      {
        id: tempId,
        name: optimisticItem.user.user_name,
        time: "Just now",
        text: commentText,
        likes: 0,
        liked: false,
        image: optimisticItem.user.user_image,
      },
      ...prev,
    ].slice(0, 3));
    setModalCommentInput("");

    if (currentPostId) {
      try {
        const response = await createComment(appInfo, {
          content: commentText,
          post_id: Number(currentPostId),
          video_id: Number(currentPostId),
        });
        if (response?.data?.success && response?.data?.data) {
          const createdData = response.data.data;
          setModalCommentsList((prev) =>
            prev.map((c) =>
              c.id === tempId ? { ...createdData, ...c, id: createdData.id || tempId } : c
            )
          );
        }
        loadCommunityComments();
      } catch (err) {
        console.error("Error creating comment:", err);
      } finally {
        setIsSubmittingModalComment(false);
      }
    } else {
      setIsSubmittingModalComment(false);
    }
  };

  const handleModalLikeComment = async (commentId, currentLiked) => {
    if (!isUserLoggedIn) {
      handleGuestCommentClick();
      return;
    }
    const newLiked = currentLiked ? 0 : 1;
    setModalCommentsList((prev) =>
      prev.map((c) => {
        if (c.id === commentId) {
          const count = Number(c.likes_count ?? c.likes ?? 0);
          return {
            ...c,
            user_has_liked: newLiked === 1,
            liked: newLiked === 1,
            likes_count: newLiked === 1 ? count + 1 : Math.max(0, count - 1),
            likes: newLiked === 1 ? count + 1 : Math.max(0, count - 1),
          };
        }
        return c;
      })
    );

    setCommentsList((prev) =>
      prev.map((c) => {
        if (c.id === commentId) {
          const count = Number(c.likes ?? 0);
          return {
            ...c,
            liked: newLiked === 1,
            likes: newLiked === 1 ? count + 1 : Math.max(0, count - 1),
          };
        }
        return c;
      })
    );

    try {
      await likeDislikeComment(appInfo, commentId, {
        liked: newLiked,
      });
    } catch (err) {
      console.error("Error liking comment:", err);
    }
  };

  const heroImageSrc =
    showDetails?.hero_image ||
    showDetails?.logo_thumb ||
    `${process.env.PUBLIC_URL}/assets/Images/hero_placeholder.jpg`;
  const heroImageUrl = /^https?:\/\//i.test(heroImageSrc)
    ? heroImageSrc
    : `${process.env.REACT_APP_IMAGE_URL}${heroImageSrc}`;
  const titleImageSrc = showDetails?.image_title;
  const titleImageUrl = titleImageSrc
    ? (/^https?:\/\//i.test(titleImageSrc)
      ? titleImageSrc
      : `${process.env.REACT_APP_IMAGE_URL}${titleImageSrc}`)
    : null;
  const numericDetailValue = (...values) => {
    const value = values.find((candidate) => candidate !== null && candidate !== undefined && candidate !== "" && !Number.isNaN(Number(candidate)));
    return value === undefined ? null : Number(value);
  };
  const reviewData = showDetails?.review_data || {};
  // const reviewData = {};
  const castNames = (showDetails?.cast || [])
    .map((castMember) => castMember?.name)
    .filter(Boolean)
    .join(", ");
  const reviewScore = numericDetailValue(reviewData?.rating);
  const hasReview = Boolean(reviewData?.short_review || reviewData?.full_review || reviewScore !== null);

  // Creators data parsing & grouping
  const creatorsCrewList = useMemo(() => {
    if (Array.isArray(showDetails?.crew) && showDetails.crew.length > 0) {
      const roleMap = new Map();
      showDetails.crew.forEach((item) => {
        const role = item?.role || "Crew";
        const name = item?.name;
        if (name) {
          if (!roleMap.has(role)) {
            roleMap.set(role, []);
          }
          if (!roleMap.get(role).includes(name)) {
            roleMap.get(role).push(name);
          }
        }
      });
      const list = [];
      if (showDetails?.director) {
        const hasDirector = Array.from(roleMap.keys()).some((r) =>
          r.toLowerCase().includes("direct")
        );
        if (!hasDirector) {
          list.push({ role: "Directed by", names: showDetails.director });
        }
      }
      roleMap.forEach((names, role) => {
        list.push({ role, names: names.join(", ") });
      });
      return list;
    }

    const list = [];
    if (showDetails?.director) {
      list.push({ role: "Directed by", names: showDetails.director });
    }
    if (showDetails?.producer) {
      list.push({ role: "Produced by", names: showDetails.producer });
    }
    if (showDetails?.music) {
      list.push({ role: "Music by", names: showDetails.music });
    }
    if (showDetails?.writer || showDetails?.writing_credits) {
      list.push({
        role: "Writing Credits",
        names: showDetails?.writer || showDetails?.writing_credits,
      });
    }

    if (list.length > 0) return list;

    return [
      { role: "Directed by", names: showDetails?.director || "Joe Burke" },
      { role: "Produced by", names: "David Gordan Green" },
      { role: "Music by", names: "Tim Rutili" },
      { role: "Writing Credits", names: "Joe Burke, Oliver Cooper" },
    ];
  }, [showDetails]);

  const creatorsCastList = useMemo(() => {
    if (Array.isArray(showDetails?.cast) && showDetails.cast.length > 0) {
      return showDetails.cast
        .filter((item) => item?.name)
        .map((item) => ({
          role: item?.role || item?.character || "",
          name: item?.name,
        }));
    }

    if (showDetails?.show_cast && typeof showDetails.show_cast === "string") {
      return showDetails.show_cast.split(",").map((name) => ({
        role: "",
        name: name.trim(),
      }));
    }

    return [
      { role: "Sammy", name: "Oliver Cooper" },
      { role: "Burt", name: "Burton Berger" },
      { role: "Sylvia", name: "Catlin Adams" },
      { role: "Steve", name: "Steven Levy" },
      { role: "Heide", name: "Olivia Luccardi" },
    ];
  }, [showDetails]);

  const ourTake = useMemo(() => {
    const raw = showDetails?.our_take;
    if (!raw) return null;
    const str = typeof raw === "string" ? raw : String(raw);
    const text = str.includes("<") && str.includes(">") ? stripHtml(str).trim() : str.trim();
    if (!text || text.toLowerCase() === "null" || text.toLowerCase() === "undefined") {
      return null;
    }
    const cleaned = text.replace(/^pause\s*\/\s*rewind\s*:?\s*/i, "").trim();
    return cleaned || null;
  }, [showDetails?.our_take]);

  useEffect(() => {
    const fontLinkId = "yowtv-archivo-font";
    if (!document.getElementById(fontLinkId)) {
      const link = document.createElement("link");
      link.id = fontLinkId;
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700&display=swap";
      document.head.appendChild(link);
    }
    const fontCondLinkId = "yowtv-archivo-font-condensed";
    if (!document.getElementById(fontCondLinkId)) {
      const link2 = document.createElement("link");
      link2.id = fontCondLinkId;
      link2.rel = "stylesheet";
      link2.href = "https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@62..125,400..900&display=swap";
      document.head.appendChild(link2);
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsCreatorsModalOpen(false);
        setIsFullReviewOpen(false);
        setIsCommentsModalOpen(false);
      }
    };
    if (isCreatorsModalOpen || isFullReviewOpen || isCommentsModalOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isCreatorsModalOpen, isFullReviewOpen, isCommentsModalOpen]);
  const userRating = numericDetailValue(userRatedCount, showDetails?.user_rating);
  const fanRatingsCount = numericDetailValue(showDetails?.number_of_rating) ?? (userRating > 0 ? 1 : 0);
  const fanScore = Math.min(
    10,
    Math.max(
      0,
      numericDetailValue(showDetails?.show_rating, userRating) ?? 0
    )
  );
  const hasFanRatings = fanRatingsCount > 0 || (userRating > 0) || fanScore > 0;
  const fanScoreDashOffset = 314 - (fanScore / 10) * 314;
  const formatFanScore = (score) => {
    if (score === null || score === undefined || Number.isNaN(Number(score))) {
      return "0.0";
    }
    const num = Number(score);
    if (num >= 10) {
      return "10";
    }
    return num.toFixed(1);
  };
  const formattedLikesCount = new Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(likesCount);
  const fallbackTeaserVideoId = useMemo(() => {
    return (
      (showDetails?.video_time && /^\d+$/.test(String(showDetails.video_time).trim()) ? String(showDetails.video_time).trim() : null) ||
      (showDetails?.videos?.[0]?.video_id && /^\d+$/.test(String(showDetails.videos[0].video_id).trim()) ? String(showDetails.videos[0].video_id).trim() : null) ||
      (selectedVideoDetails?.video_id && /^\d+$/.test(String(selectedVideoDetails.video_id).trim()) ? String(selectedVideoDetails.video_id).trim() : null) ||
      "186340"
    );
  }, [showDetails, selectedVideoDetails]);

  const similarItems = useMemo(() => {
    const rawList = similarVideos?.length > 0 ? similarVideos : MOCK_SIMILAR_VIDEOS;
    return rawList.map((item) => {
      // Use video_time (may be a URL or a number), fallback to video_id
      const resolvedVideoTime = item?.video_time ?? item?.video_id ?? null;

      return {
        ...item,
        show_name: item?.show_name || item?.title || item?.name,
        synopsis: item?.synopsis || item?.description || "Experience exclusive shows and stories on YOW TV.",
        duration_text: item?.duration_text || (item?.duration ? `${item.duration}m` : "45m"),
        video_time: resolvedVideoTime,
        fallback_video_id: fallbackTeaserVideoId,
        teaser: item?.teaser,
      };
    });
  }, [similarVideos, fallbackTeaserVideoId]);

  const similarSwiperRef = useRef(null);
  const [isSimilarBeginning, setIsSimilarBeginning] = useState(true);
  const [isSimilarEnd, setIsSimilarEnd] = useState(false);
  const [similarActiveIndex, setSimilarActiveIndex] = useState(0);
  const [isSimilarNavigating, setIsSimilarNavigating] = useState(false);
  const similarNavTimeoutRef = useRef(null);

  const updateSimilarNavigationState = useCallback((swiper) => {
    if (!swiper) return;
    setIsSimilarBeginning(swiper.isBeginning ?? true);
    setIsSimilarEnd(swiper.isEnd ?? false);
    setSimilarActiveIndex(swiper.activeIndex ?? 0);
  }, []);

  useEffect(() => {
    if (similarSwiperRef.current) {
      similarSwiperRef.current.update();
      updateSimilarNavigationState(similarSwiperRef.current);
    }
  }, [similarItems, updateSimilarNavigationState]);

  useEffect(() => {
    return () => {
      if (similarNavTimeoutRef.current) clearTimeout(similarNavTimeoutRef.current);
    };
  }, []);

  const handleSimilarPrev = (e) => {
    if (e) {
      if (e.preventDefault) e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
    }
    setIsSimilarNavigating(true);
    if (similarNavTimeoutRef.current) clearTimeout(similarNavTimeoutRef.current);
    similarNavTimeoutRef.current = setTimeout(() => {
      setIsSimilarNavigating(false);
    }, 600);
    if (similarSwiperRef.current) {
      similarSwiperRef.current.slidePrev();
      updateSimilarNavigationState(similarSwiperRef.current);
    }
  };

  const handleSimilarNext = (e) => {
    if (e) {
      if (e.preventDefault) e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
    }
    setIsSimilarNavigating(true);
    if (similarNavTimeoutRef.current) clearTimeout(similarNavTimeoutRef.current);
    similarNavTimeoutRef.current = setTimeout(() => {
      setIsSimilarNavigating(false);
    }, 600);
    if (similarSwiperRef.current) {
      similarSwiperRef.current.slideNext();
      updateSimilarNavigationState(similarSwiperRef.current);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={`yowDetailsScreen ${isRTL ? "rtl" : ""}`} role="main">
      {/* ================= HERO BANNER SECTION (1440x720 Aesthetic) ================= */}
      <div className="yow-hero-section">
        <div className="yow-hero-bg-wrapper">
          <img src={heroImageUrl} alt={showDetails?.show_name} className="yow-hero-img" />
          {/* Multi-layered Dark Gradient Overlays matching Figma SVG viewBox="0 0 1440 720" */}
          <div className="yow-hero-radial-1" />
          <div className="yow-hero-radial-2" />
          <div className="yow-hero-linear-dark" />
        </div>

        {/* Video Player Modal/Overlay if active */}
        {isTrailer && (
          <div className="yow-trailer-overlay">
            <div className="yow-trailer-close" onClick={() => setIsTrailer(false)}>
              <Closeicon />
            </div>
            <div className="yow-trailer-player">{videoPlayer}</div>
          </div>
        )}

        {isFullReviewOpen && (
          <div className="yow-full-review-overlay" role="dialog" aria-modal="true" aria-labelledby="yow-full-review-title">
            <div className="yow-full-review-modal">
              <button
                type="button"
                className="yow-full-review-close"
                onClick={() => setIsFullReviewOpen(false)}
                aria-label="Close full review"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
                  <path d="M14.25 14.25L0.75 0.75" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.25 0.75L0.75 14.25" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="yow-full-review-header">
                {titleImageUrl && (
                  <img
                    className="yow-full-review-title-image"
                    src={titleImageUrl}
                    alt=""
                  />
                )}
                <div className="yow-full-review-heading-row">
                  <h2 id="yow-full-review-title">{showDetails?.show_name || "Show review"}</h2>
                  {reviewScore !== null && <strong>{reviewScore}<span>/10</span></strong>}
                </div>
                <p>{showDetails?.director ? `Director: ${showDetails.director}` : ""}{showDetails?.year ? ` · ${showDetails.year}` : ""}</p>
              </div>
              <div className="yow-full-review-body">
                {(reviewData?.full_review || "No full review is available for this show yet.")
                  .split(/\n\s*\n/)
                  .map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* Full Creators Modal */}
        {isCreatorsModalOpen && (
          <div
            className="yow-creators-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="yow-creators-modal-title"
            onClick={() => setIsCreatorsModalOpen(false)}
          >
            <div
              className="yow-creators-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="yow-creators-modal-header">
                <h2 id="yow-creators-modal-title" className="yow-creators-modal-title">
                  Creators
                </h2>
                <button
                  type="button"
                  className="yow-creators-modal-close"
                  onClick={() => setIsCreatorsModalOpen(false)}
                  aria-label="Close creators modal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M14.5 14.5L1.5 1.5M14.5 1.5L1.5 14.5"
                      stroke="#D1D1D0"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="yow-creators-modal-body">
                {/* Section 1: Crew / Credits */}
                {creatorsCrewList.length > 0 && (
                  <div className="yow-creators-section yow-creators-crew-section">
                    {creatorsCrewList.map((crewItem, idx) => (
                      <div className="yow-creators-row" key={`crew-${idx}`}>
                        <span className="yow-creators-role">{crewItem.role}</span>
                        <span className="yow-creators-name">{crewItem.names}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Divider between Crew and Cast */}
                {creatorsCrewList.length > 0 && creatorsCastList.length > 0 && (
                  <div className="yow-creators-divider" />
                )}

                {/* Section 2: Cast / Characters */}
                {creatorsCastList.length > 0 && (
                  <div className="yow-creators-section yow-creators-cast-section">
                    {creatorsCastList.map((castItem, idx) => (
                      <div className="yow-creators-row" key={`cast-${idx}`}>
                        <span className="yow-creators-role">{castItem.role}</span>
                        <span className="yow-creators-name">{castItem.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Full Comments Modal (Matching Screenshot) */}
        {isCommentsModalOpen && (
          <div
            className="yow-full-comments-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="yow-full-comments-modal-title"
            onClick={() => setIsCommentsModalOpen(false)}
          >
            <div
              className="yow-full-comments-modal"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="yow-full-comments-modal-header">
                <div className="yow-full-comments-title-group">
                  <h2
                    id="yow-full-comments-modal-title"
                    className="yow-full-comments-title"
                  >
                    Comments
                  </h2>
                  <span className="yow-full-comments-count">
                    {totalCommunityComments || modalCommentsList.length || ""}
                  </span>
                </div>
                <button
                  type="button"
                  className="yow-full-comments-close"
                  onClick={() => setIsCommentsModalOpen(false)}
                  aria-label="Close comments modal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M14.5 14.5L1.5 1.5M14.5 1.5L1.5 14.5"
                      stroke="#D1D1D0"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              {/* Modal Composer */}
              <div className="yow-full-comments-composer">
                <div className="yow-full-comments-composer-avatar">
                  {userDetails?.user_image ? (
                    <img src={userDetails.user_image} alt="" />
                  ) : (
                    <span>
                      {userDetails?.first_name?.[0] ||
                        user?.first_name?.[0] ||
                        (typeof user === "string" && user[0] ? user[0].toUpperCase() : "U")}
                    </span>
                  )}
                </div>
                <div className="yow-full-comments-input-wrapper">
                  <input
                    type="text"
                    className="yow-full-comments-input"
                    placeholder="Add a comment..."
                    value={modalCommentInput}
                    onChange={(e) => setModalCommentInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        handleModalAddComment();
                      }
                    }}
                    disabled={isSubmittingModalComment}
                  />
                  {modalCommentInput.trim() && (
                    <button
                      type="button"
                      className="yow-full-comments-post-btn"
                      onClick={handleModalAddComment}
                      disabled={isSubmittingModalComment}
                    >
                      {isSubmittingModalComment ? "Posting..." : "Post"}
                    </button>
                  )}
                </div>
              </div>

              {/* Modal Comments List */}
              <div className="yow-full-comments-list">
                {commentsLoading ? (
                  <div className="yow-full-comments-loading">
                    <div className="yow-full-comments-spinner" />
                    <span>Loading comments...</span>
                  </div>
                ) : modalCommentsList.length === 0 ? (
                  <div className="yow-full-comments-empty">
                    <span>No comments yet. Be the first to share what you thought.</span>
                  </div>
                ) : (
                  modalCommentsList.map((item, idx) => {
                    const isLiked = Boolean(item.user_has_liked || item.liked || item.liked_flag);
                    const likesCount = Number(item.likes_count ?? item.likes ?? item.like_count ?? 0);
                    const commentText = item.content || item.text || item.comment || item.comment_text || "";
                    const handle = formatUserHandle(item.user, item.name || item.user_name || item.username);
                    const timeAgo = formatShortTimeAgo(item.created_at || item.time);

                    return (
                      <div key={item.id || idx} className="yow-full-comments-item">
                        <div className="yow-full-comments-item-avatar">
                          {item.user?.user_image || item.image ? (
                            <img src={item.user?.user_image || item.image} alt="" />
                          ) : (
                            <span>{getAvatarInitial(item.user, item.name)}</span>
                          )}
                        </div>
                        <div className="yow-full-comments-item-content">
                          <div className="yow-full-comments-item-header">
                            <span className="yow-full-comments-handle">{handle}</span>
                            <span className="yow-full-comments-time">{timeAgo}</span>
                          </div>
                          <div className="yow-full-comments-text">{commentText}</div>
                        </div>
                        <button
                          type="button"
                          className={`yow-full-comments-like-btn ${isLiked ? "liked" : ""}`}
                          onClick={() => handleModalLikeComment(item.id, isLiked)}
                          aria-label={isLiked ? "Unlike comment" : "Like comment"}
                        >
                          {isLiked ? (
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.625 5.0075C14.4842 4.84795 14.3111 4.72019 14.1171 4.63269C13.9231 4.54519 13.7128 4.49996 13.5 4.5H10V3.5C10 2.83696 9.73661 2.20107 9.26777 1.73223C8.79893 1.26339 8.16304 1 7.5 1C7.40711 0.999934 7.31604 1.02574 7.237 1.07454C7.15795 1.12333 7.09407 1.19318 7.0525 1.27625L4.69125 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V12.5C1 12.7652 1.10536 13.0196 1.29289 13.2071C1.48043 13.3946 1.73478 13.5 2 13.5H12.75C13.1154 13.5001 13.4684 13.3668 13.7425 13.1252C14.0166 12.8835 14.1931 12.5501 14.2388 12.1875L14.9888 6.1875C15.0153 5.97626 14.9966 5.76179 14.9339 5.55833C14.8712 5.35488 14.7659 5.16711 14.625 5.0075ZM2 7H4.5V12.5H2V7Z" fill="#FF640A" />
                            </svg>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2 6.5H5V13H2C1.86739 13 1.74021 12.9473 1.64645 12.8536C1.55268 12.7598 1.5 12.6326 1.5 12.5V7C1.5 6.86739 1.55268 6.74021 1.64645 6.64645C1.74021 6.55268 1.86739 6.5 2 6.5Z" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M5 6.5L7.5 1.5C8.03043 1.5 8.53914 1.71071 8.91421 2.08579C9.28929 2.46086 9.5 2.96957 9.5 3.5V5H13.5C13.6419 5.00004 13.7821 5.03026 13.9113 5.08865C14.0406 5.14704 14.156 5.23227 14.2498 5.33867C14.3436 5.44507 14.4137 5.57021 14.4555 5.70579C14.4972 5.84136 14.5096 5.98426 14.4919 6.125L13.7419 12.125C13.7114 12.3666 13.5939 12.5888 13.4113 12.7499C13.2286 12.911 12.9935 12.9999 12.75 13H5" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                          {likesCount > 0 && (
                            <span className="yow-full-comments-like-count">{likesCount}</span>
                          )}
                        </button>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        )}

        <AddToPlaylistPopup
          isOpen={showAddtoPlaylistPopup}
          onClose={() => setShowAddtoPlaylistPopup(false)}
          showDetails={showDetails}
          videoId={selectedVideoDetails?.video_id || (showDetails?.single_video === 1 ? showDetails?.videos?.[0]?.video_id : undefined)}
          setWatchlistStatus={setWatchlistStatus}
        />

        {/* Hero Details Content */}
        <div className="yow-hero-content-container">
          {/* Show Title */}
          <h1 className="yow-hero-title-text">
            {showDetails?.show_name || "Burt"}
          </h1>

          {ourTake && (
            <div className="yow-hero-description">
              <span className="yow-description-lead">Pause/Rewind:</span>{" "}
              {ourTake}
            </div>
          )}

          {/* Directed by */}
          <div className="yow-directed-by">
            Directed by <span>{showDetails?.director || "Jody Shapiro"}</span>
          </div>

          {/* Action CTAs Row */}
          <div className="yow-hero-cta-row">
            {/* Primary PLAY Button */}
            {!showDetails?.hide_play_button && (
              <button
                className="yow-btn-play"
                onClick={() =>
                  handleWatchNowClick(
                    selectedVideoDetails,
                    showId,
                    setSelectedVideoDetails,
                    showDetails,
                    categories,
                    thumbnailOrientation,
                    appInfo,
                    user,
                    setRefetchTrigger
                  )
                }
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
                <span>{showDetails?.button_text || <Translate textKey={"play"} />}</span>
              </button>
            )}

            {/* Glassmorphism Watchlist Button */}
            <button
              className={`yow-btn-watchlist ${watchlistStatus === "added" ? "active" : ""}`}
              onClick={handleWatchlistToggle}
              title={watchlistStatus === "added" ? "In Watchlist" : "Add to Watchlist"}
              aria-label={watchlistStatus === "added" ? "In Watchlist" : "Add to Watchlist"}
            >
              <span className="yow-btn-watchlist-icon" aria-hidden="true">
                {watchlistStatus === "added" ? (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                )}
              </span>
              <span className="yow-btn-watchlist-text">
                {watchlistStatus === "added" ? "IN WATCHLIST" : "WATCHLIST"}
              </span>
            </button>

          </div>

        </div>

        <button
          className="yow-btn-mute"
          onClick={() => setIsMuted(!isMuted)}
          title={isMuted ? "Unmute sound" : "Mute sound"}
        >
          {isMuted ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 5L6 9H2v6h4l5 4V5z" />
              <line x1="23" y1="9" x2="17" y2="15" />
              <line x1="17" y1="9" x2="23" y2="15" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
            </svg>
          )}
        </button>
      </div>

      <div className="yow-details-meta-row" aria-label="Show metadata">
        {(showDetails?.categories?.length > 0
          ? showDetails.categories.map((category) => category?.category_name)
          : ["Comedy", "Drama"]
        ).map((category, index) => (
          <span key={`${category}-${index}`} className="yow-details-meta-item">
            {category}
          </span>
        ))}
        {showDetails?.rating && <span className="yow-details-meta-item">{showDetails?.rating}</span>}
        {showDetails?.year && <span className="yow-details-meta-item">{showDetails?.year}</span>}
        <button
          type="button"
          className={`yow-details-meta-item yow-details-like-item ${hasLiked ? "liked" : ""}`}
          onClick={handleLikeToggle}
          aria-label="Like this show"
        >
          <span className="yow-details-heart" aria-hidden="true">
            {hasLiked ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M18.75 7.96875C18.75 13.4375 10.6414 17.8641 10.2961 18.0469C10.2051 18.0958 10.1033 18.1215 10 18.1215C9.89665 18.1215 9.79492 18.0958 9.70391 18.0469C9.35859 17.8641 1.25 13.4375 1.25 7.96875C1.25145 6.68455 1.76223 5.45337 2.6703 4.5453C3.57837 3.63723 4.80955 3.12645 6.09375 3.125C7.70703 3.125 9.11953 3.81875 10 4.99141C10.8805 3.81875 12.293 3.125 13.9062 3.125C15.1904 3.12645 16.4216 3.63723 17.3297 4.5453C18.2378 5.45337 18.7486 6.68455 18.75 7.96875Z" fill="#FF640A" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 17.5C10 17.5 1.875 13.125 1.875 7.96875C1.875 6.84987 2.31947 5.77681 3.11064 4.98564C3.90181 4.19447 4.97487 3.75 6.09375 3.75C7.85859 3.75 9.37031 4.71172 10 6.25C10.6297 4.71172 12.1414 3.75 13.9062 3.75C15.0251 3.75 16.0982 4.19447 16.8894 4.98564C17.6805 5.77681 18.125 6.84987 18.125 7.96875C18.125 13.125 10 17.5 10 17.5Z" stroke="#D1D1D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </span>
          <span>{formattedLikesCount}</span>
        </button>
      </div>

      {/* ================= MIDDLE SECTION (SYNOPSIS & CREATORS) ================= */}
      <div className="yow-middle-container">
        <div className="yow-middle-grid">
          {/* Left Column: Synopsis */}
          <div className="yow-synopsis-column">
            {ourTake && (
              <div className="yow-pause-rewind">
                <span className="yow-description-lead">Pause/Rewind:</span>{" "}
                {ourTake}
              </div>
            )}
            <h2 className="yow-column-heading">Synopsis</h2>
            <div className="yow-synopsis-body">
              <p>
                {showDetails?.synopsis ||
                  showDetails?.video_description ||
                  "An affectionate, engrossing look at Burt Shavitz, the reclusive bee-keeper who became the iconic face of Burt's Bees. The film explores his eccentric life, his complicated relationship with co-founder Roxanne Quimby, and his transition into an unexpected global pop-culture celebrity."}
              </p>
            </div>
          </div>

          {/* Right Column: Creators */}
          <div className="yow-creators-column">
            <div
              className="yow-creators-header"
              onClick={() => setIsCreatorsModalOpen(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setIsCreatorsModalOpen(true);
                }
              }}
              aria-label="View all creators"
            >
              <h2 className="yow-column-heading">Creators</h2>
              <span className="yow-heading-arrow" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 3L11 8L6 13" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
            <div className="yow-creators-body">
              <div className="yow-creator-detail-row">
                <span className="yow-creator-label">Directed by</span>
                <span className="yow-creator-value">
                  {showDetails?.director || "Jody Shapiro"}
                </span>
              </div>
              <div className="yow-creator-detail-row">
                <span className="yow-creator-label">Starring</span>
                <span className="yow-creator-value">
                  {castNames || "Not available"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= COMMUNITY ROW (FILM THREAT, FAN SCORE, COMMENTS) ================= */}
      <div className="yow-community-container">
        <div className="yow-community-grid">
          {/* Card 1: Film Threat Review */}
          <div className={`yow-community-card yow-review-card ${!hasReview ? "is-empty" : ""}`}>
            {hasReview ? (
              <>
                <div className="yow-review-score-panel">
                  <span className="yow-rating-score-badge">{reviewScore ?? "-"}</span>
                  <span className="yow-rating-denom">/10</span>
                  {titleImageUrl ? (
                    <img
                      className="yow-title-image"
                      src={titleImageUrl}
                      alt={`${showDetails?.show_name || "Show"} title`}
                    />
                  ) : (
                    <span className="yow-brand-tag">{showDetails?.show_name || "Burt"}</span>
                  )}
                </div>
                <div className="yow-review-copy">
                  <blockquote className="yow-card-quote">
                    {reviewData?.short_review}
                  </blockquote>
                  <div className="yow-review-footer">
                    <span>{reviewData?.reviewed_by || "Review details unavailable"}</span>
                    <button
                      type="button"
                      className="yow-card-action-link"
                      onClick={() => reviewData?.full_review && setIsFullReviewOpen(true)}
                      disabled={!reviewData?.full_review}
                    >
                      {reviewData?.full_review ? "Read full review" : "Review unavailable"} <span aria-hidden="true">›</span>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="yow-review-empty-state">
                <div className="yow-review-empty-icon-panel">
                  <svg className="yow-review-empty-icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M8 54V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H54C54.5304 12 55.0391 12.2107 55.4142 12.5858C55.7893 12.9609 56 13.4696 56 14V54L48 50L40 54L32 50L24 54L16 50L8 54Z" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37 27H46" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37 37H46" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M28 24H18V40H28V24Z" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="yow-review-empty-desc">
                  <div className="title-wrapper"><span className="title">No critic review yet</span></div>
                  <div><span className="subtitle">Check back soon.</span></div>
                  <div><span className="subtitle">We'll add one when it's published.</span></div>
                </div>
              </div>
            )}
          </div>

          {/* Card 2: Fan Score Ring Gauge */}
          <div className={`yow-community-card yow-fanscore-card ${!hasFanRatings && !(userRating > 0) ? "is-empty" : ""} ${isEditingRating ? "is-editing" : ""}`}>
            <div className="yow-fanscore-main">
              <div className="yow-gauge-wrapper">
                <svg className="yow-gauge-svg" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="50" className="yow-gauge-track" />
                  <circle
                    cx="60"
                    cy="60"
                    r="50"
                    className="yow-gauge-fill"
                    style={{ strokeDashoffset: fanScoreDashOffset }}
                  />
                </svg>
                <div className={`yow-gauge-score-box ${!hasFanRatings && !(userRating > 0) ? "is-empty" : ""}`}>
                  {!hasFanRatings && !(userRating > 0) ? (
                    <>
                      <span className="yow-no-ratings-dash">_</span>
                      <span className="yow-no-ratings-label">No ratings</span>
                    </>
                  ) : (
                    <>
                      <span className="yow-score-num">{formatFanScore(fanScore)}</span>
                      <span className="yow-score-denom">/10</span>
                    </>
                  )}
                </div>
              </div>
              <div className="yow-fanscore-details">
                {!hasFanRatings && !(userRating > 0) ? (
                  <div className="yow-first-rating">
                    <span className="yow-fanscore-label">It's the first to rate {showDetails?.show_name || "this show"}</span>
                    <div className="yow-rating-options">
                      {Array.from({ length: 10 }, (_, index) => index + 1).map((rating) => (
                        <button
                          type="button"
                          key={rating}
                          className="yow-rating-option"
                          ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                          onClick={() => handleInitialRating(rating)}
                        >
                          {rating}
                        </button>
                      ))}
                    </div>
                  </div>
                ) : isEditingRating ? (
                  <div className="yow-rating-editor">
                    <span className="yow-fanscore-label">Changed your mind on {showDetails?.show_name || "this show"}?</span>
                    <div className="yow-rating-options">
                      {Array.from({ length: 10 }, (_, index) => index + 1).map((rating) => (
                        <button
                          type="button"
                          key={rating}
                          className={`yow-rating-option ${draftRating === rating ? "selected" : ""}`}
                          ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                          onClick={() => setDraftRating(rating)}
                        >
                          {rating}
                        </button>
                      ))}
                    </div>
                    <div className="yow-rating-editor-actions">
                      <button type="button" onClick={handleRatingSave} disabled={!draftRating}>Save</button>
                      <button type="button" onClick={handleRatingCancel}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="fan-rating-wrapper">
                      <div>
                        <span className="yow-fanscore-label">Your rating</span>
                        <div className="yow-rating-action-row">
                          <button
                            type="button"
                            className="yow-user-rating-pill"
                            ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                            onClick={() => {
                              setDraftRating(userRating);
                              setIsEditingRating(true);
                            }}
                          >
                            <span>{userRating ?? "Rate"}</span>
                          </button>
                          <button type="button" className="yow-change-rating" onClick={() => {
                            setDraftRating(userRating);
                            setIsEditingRating(true);
                          }}>Change</button>
                        </div>
                      </div>

                      <div className="yow-ratings-total">
                        <span>Fan ratings</span>
                        <strong>{fanRatingsCount.toLocaleString()}</strong>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

          </div>

          {/* Card 3: Comments Section */}
          <div className={`yow-community-card yow-comments-card ${commentsList.length === 0 ? "is-empty" : ""}`}>
            <div
              className="yow-comments-card-header"
              onClick={() => !isUserLoggedIn ? handleGuestCommentClick() : setIsCommentsModalOpen(true)}
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  !isUserLoggedIn ? handleGuestCommentClick() : setIsCommentsModalOpen(true);
                }
              }}
              aria-label="View all comments"
            >
              <>
                <h3>Comments</h3>
                <div className="comments-count">
                  {totalCommunityComments > 0
                    ? ` ${totalCommunityComments}`
                    : commentsList.length > 0
                      ? ` ${commentsList.length}`
                      : ""}
                </div>
              </>
              <span className="yow-heading-arrow" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 3L11 8L6 13" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>

            {/* Composer Box */}
            <div
              className={`yow-composer-box ${!isUserLoggedIn ? "is-guest" : ""}`}
              onClick={!isUserLoggedIn ? handleGuestCommentClick : undefined}
            >
              <div className="yow-user-avatar">
                {isUserLoggedIn ? (
                  userDetails?.user_image ? (
                    <img src={userDetails.user_image} alt="" />
                  ) : (
                    userDetails?.first_name?.[0] ||
                    user?.first_name?.[0] ||
                    (typeof user === "string" && user[0] ? user[0].toUpperCase() : "U")
                  )
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#D1D1D0"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                )}
              </div>
              <input
                type="text"
                placeholder={isUserLoggedIn ? "Add a comment..." : "Log in to add a comment..."}
                value={isUserLoggedIn ? newComment : ""}
                onChange={(e) => {
                  if (isUserLoggedIn) {
                    setNewComment(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (!isUserLoggedIn) {
                    e.preventDefault();
                    handleGuestCommentClick();
                    return;
                  }
                  if (e.key === "Enter") {
                    handleAddComment();
                  }
                }}
                onFocus={(e) => {
                  if (!isUserLoggedIn) {
                    e.target.blur();
                    handleGuestCommentClick();
                  }
                }}
                onClick={(e) => {
                  if (!isUserLoggedIn) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleGuestCommentClick();
                  }
                }}
                readOnly={!isUserLoggedIn}
                className="yow-comment-input"
                style={{ cursor: !isUserLoggedIn ? "pointer" : "text" }}
                title={!isUserLoggedIn ? "Log in to add a comment" : ""}
              />
              <button
                className="yow-comment-submit-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isUserLoggedIn) {
                    handleGuestCommentClick();
                  } else {
                    handleAddComment();
                  }
                }}
                type="button"
                title={!isUserLoggedIn ? "Log in to add a comment" : "Post comment"}
              >
                {isUserLoggedIn ? "Post" : "Log in"}
              </button>
            </div>

            {/* Comments List */}
            <div className={`yow-comments-stream ${commentsList.length === 0 ? "is-empty" : ""}`}>
              {commentsList.length === 0 ? (
                <div className="yow-comments-empty-state">
                  <div>
                    <svg className="yow-empty-state-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M4.06255 17.25C3.04388 15.3469 2.74312 13.141 3.21513 11.0347C3.68715 8.92834 4.90048 7.0618 6.63389 5.77542C8.36731 4.48904 10.5053 3.86851 12.6581 4.02699C14.8108 4.18546 16.8349 5.11239 18.3613 6.63874C19.8876 8.16509 20.8146 10.1892 20.973 12.3419C21.1315 14.4947 20.511 16.6327 19.2246 18.3661C17.9382 20.0995 16.0717 21.3129 13.9653 21.7849C11.859 22.2569 9.65315 21.9562 7.75005 20.9375L4.28005 21.9575C4.10775 22.0081 3.925 22.0113 3.751 21.9669C3.577 21.9225 3.41816 21.8321 3.29118 21.7051C3.1642 21.5781 3.07375 21.4193 3.02935 21.2453C2.98494 21.0713 2.9882 20.8885 3.0388 20.7162L4.06255 17.25Z" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M20.4924 10.0138C22.0043 10.096 23.4711 10.5583 24.7568 11.3579C26.0426 12.1576 27.1059 13.2686 27.8482 14.5883C28.5904 15.908 28.9878 17.3937 29.0034 18.9077C29.019 20.4218 28.6524 21.9153 27.9374 23.25L28.9574 26.72C29.008 26.8923 29.0113 27.0751 28.9669 27.2491C28.9225 27.4231 28.8321 27.5819 28.7051 27.7089C28.5781 27.8359 28.4193 27.9263 28.2453 27.9708C28.0713 28.0152 27.8885 28.0119 27.7162 27.9613L24.2499 26.9375C23.1049 27.5499 21.841 27.9074 20.5449 27.9856C19.2488 28.0638 17.9511 27.8608 16.7408 27.3905C15.5304 26.9202 14.4361 26.1938 13.5328 25.261C12.6295 24.3282 11.9386 23.2111 11.5074 21.9863" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <div><strong>No comments yet</strong></div>
                    <div style={{ marginTop: "5px" }}><span>Be the first to share what you thought.</span></div>
                  </div>
                </div>
              ) : (
                commentsList.slice(0, 3).map((item, idx) => (
                  <div key={item.id || idx} className="yow-comment-row">
                    <div className="yow-comment-author-avatar">
                      {item.image ? <img src={item.image} alt="" /> : item.name[0]}
                    </div>
                    <div className="yow-comment-content">
                      <div className="yow-comment-meta">
                        <span className="yow-author-name">{formatUserHandle(item.user, item.name)}</span>
                        <span className="yow-comment-time">{item.time}</span>
                      </div>
                      <p className="yow-comment-text">{item.text}</p>
                    </div>
                    <button
                      type="button"
                      className={`yow-comment-like-btn ${item.liked ? "liked" : ""}`}
                      onClick={() => handleLikeComment(idx)}
                      aria-label={item.liked ? "Unlike comment" : "Like comment"}
                    >
                      {item.liked ? (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.625 5.0075C14.4842 4.84795 14.3111 4.72019 14.1171 4.63269C13.9231 4.54519 13.7128 4.49996 13.5 4.5H10V3.5C10 2.83696 9.73661 2.20107 9.26777 1.73223C8.79893 1.26339 8.16304 1 7.5 1C7.40711 0.999934 7.31604 1.02574 7.237 1.07454C7.15795 1.12333 7.09407 1.19318 7.0525 1.27625L4.69125 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V12.5C1 12.7652 1.10536 13.0196 1.29289 13.2071C1.48043 13.3946 1.73478 13.5 2 13.5H12.75C13.1154 13.5001 13.4684 13.3668 13.7425 13.1252C14.0166 12.8835 14.1931 12.5501 14.2388 12.1875L14.9888 6.1875C15.0153 5.97626 14.9966 5.76179 14.9339 5.55833C14.8712 5.35488 14.7659 5.16711 14.625 5.0075ZM2 7H4.5V12.5H2V7Z" fill="#FF640A" />
                        </svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 6.5H5V13H2C1.86739 13 1.74021 12.9473 1.64645 12.8536C1.55268 12.7598 1.5 12.6326 1.5 12.5V7C1.5 6.86739 1.55268 6.74021 1.64645 6.64645C1.74021 6.55268 1.86739 6.5 2 6.5Z" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M5 6.5L7.5 1.5C8.03043 1.5 8.53914 1.71071 8.91421 2.08579C9.28929 2.46086 9.5 2.96957 9.5 3.5V5H13.5C13.6419 5.00004 13.7821 5.03026 13.9113 5.08865C14.0406 5.14704 14.156 5.23227 14.2498 5.33867C14.3436 5.44507 14.4137 5.57021 14.4555 5.70579C14.4972 5.84136 14.5096 5.98426 14.4919 6.125L13.7419 12.125C13.7114 12.3666 13.5939 12.5888 13.4113 12.7499C13.2286 12.911 12.9935 12.9999 12.75 13H5" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                      {item.likes > 0 && (
                        <span className="yow-comment-like-count">{item.likes}</span>
                      )}
                    </button>
                  </div>
                ))
              )}
            </div>

            {/* {(totalCommunityComments > 3 || modalCommentsList.length > 3) && (
              <div className="yow-comments-view-all-wrapper">
                <button
                  type="button"
                  className="yow-comments-view-all-link"
                  onClick={() => setIsCommentsModalOpen(true)}
                >
                  View all {totalCommunityComments || modalCommentsList.length} comments
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            )} */}
          </div>
        </div>
      </div>

      {/* ================= CAROUSEL / YOU MAY ALSO LIKE SECTION ================= */}
      <div className="yow-carousel-container">
        <h2 className="yow-carousel-heading">
          <Translate textKey={"you_may_also_like"} />
        </h2>
        <div className="yow-similar-wrapper" style={{ position: "relative" }}>
          <Swiper
            modules={[Navigation]}
            navigation={false}
            onSwiper={(swiper) => {
              similarSwiperRef.current = swiper;
              updateSimilarNavigationState(swiper);
            }}
            onSlideChange={updateSimilarNavigationState}
            onSlideChangeTransitionEnd={updateSimilarNavigationState}
            onTransitionEnd={updateSimilarNavigationState}
            observer={true}
            observeParents={true}
            watchSlidesProgress={true}
            speed={450}
            spaceBetween={20}
            slidesPerView={6}
            slidesPerGroup={6}
            allowTouchMove={true}
            simulateTouch={true}
            touchRatio={1}
            touchAngle={30}
            threshold={5}
            grabCursor={true}
            touchStartPreventDefault={false}
            touchMoveStopPropagation={false}
            className="yow-similar-swiper"
            breakpoints={{
              320: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 },
              480: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 10 },
              641: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 12 },
              768: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 14 },
              980: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 20 },
              1200: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 20 },
            }}
          >
            {similarItems.map((item, index) => {
              return (
                <SwiperSlide key={item?.show_id || item?.video_id || index}>
                  <div className="show" style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                    <ShowCard
                      data={item}
                      metaData={true}
                      type="SIMILAR_VIDEOS"
                      thumbnailOrientation="PORTRAIT"
                      isPriority={index < 6}
                      disableHover={isSimilarNavigating}
                      disableHoverPreview={isSimilarNavigating}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="yow-similar-controls">
            <button
              type="button"
              className={`yow-similar-prev ${isSimilarBeginning ? "swiper-button-disabled" : ""}`}
              aria-label="Previous slide"
              disabled={isSimilarBeginning}
              onClick={handleSimilarPrev}
            >
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <rect width="44" height="44" fill="#4D4C4B" />
                <path d="M24.5 15.75L18.25 22L24.5 28.25" stroke="#F6F6F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              type="button"
              className={`yow-similar-next ${isSimilarEnd ? "swiper-button-disabled" : ""}`}
              aria-label="Next slide"
              disabled={isSimilarEnd}
              onClick={handleSimilarNext}
            >
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <rect width="44" height="44" fill="#4D4C4B" />
                <path d="M19.5 15.75L25.75 22L19.5 28.25" stroke="#F6F6F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YowDetailsScreen;
